import script from "./BaseTabsTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTabsTab.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTabsTab.vue?vue&type=style&index=0&id=828354f6&lang=scss"

const __exports__ = script;

export default __exports__